import { render } from "./FloatView.vue?vue&type=template&id=2d191a16&scoped=true&ts=true"
import script from "./FloatView.vue?vue&type=script&lang=ts"
export * from "./FloatView.vue?vue&type=script&lang=ts"

import "./FloatView.vue?vue&type=style&index=0&id=2d191a16&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d191a16"]])

export default __exports__